import React, { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/commonStyle.css";
import EstimatedFareReadOnly from '../components/booking/components/items/EstimatedFareReadOnly'
import BookingBasicDetailsReadOnly from '../components/booking/components/items/BookingBasicDetailsReadOnly'
import BookingCommunicationDetailsReadOnly from '../components/booking/components/items/BookingCommunicationDetailsReadOnly'
import BookingCabDetails from '../components/booking/components/items/BookingCabDetails'
import { sendInvoiceToUserWhatsApp } from "../components/services/invoiceService"



const UserBookingDetailsReadOnly: React.FC = () => {
  const location = useLocation();
  const booking = location.state.booking
  const navigate = useNavigate();

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleBackBtn = () => {
    navigate("/userCompletedRidesPage");
  };

  const handleInvoice = async () => {
    setOpenSnackbar(true);
    await sendInvoiceToUserWhatsApp(booking.bookingId)
  };

  return (
    <>
      <div>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={2000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          className="snackbarPosition"
          aria-live="assertive"
        >
          <Alert severity="success" sx={{ width: '100%' }}>
            Your Invoice has been sent to your WHATSAPP successfully!
        </Alert>
        </Snackbar>
        <div className="container my-3" style={{ fontSize: '0.875rem' }}>

          <div className="row justify-content-center px-0">

            <div className="col-12 col-lg-10 col-xl-9 px-0">

              <div className="row g-4">
                {/* LEFT: Route + Contact Info */}
                <div className="col-12 col-lg-8 d-flex flex-column gap-3">
                  <BookingBasicDetailsReadOnly booking={booking} />
                  <BookingCabDetails booking={booking} />
                  <BookingCommunicationDetailsReadOnly booking={booking} />
                </div>

                {/* RIGHT: Payment Card */}
                <div className="col-12 col-lg-4">
                  <EstimatedFareReadOnly booking={booking} />
                  {booking.status !== "CANCELLED" && booking.payment.status === "INVOICE_GENERATED" ? (
                    <button
                      type="button"
                      className="btn w-100 btn-outline-success customText mt-2"
                      onClick={handleInvoice}
                    >
                      SEND INVOICE TO MY WHATSAPP
                    </button>
                  ) : (
                      <>
                        {booking.status !== "CANCELLED" && (
                          <div className="card rounded-3 mt-1">
                            <div className="card-body">
                              <p className="fw-bold customText text-center mb-0">
                                Your Invoice is not yet generated. Please wait for some time.
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                </div>
              </div>

              <div className="d-flex flex-column gap-2 col-lg-8 mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary w-100 back-button"
                  onClick={handleBackBtn}
                >
                  Back
               </button>
              </div>

            </div>

          </div>
        </div>

      </div>

    </>

  );
};

export default UserBookingDetailsReadOnly;
